// extracted by mini-css-extract-plugin
export default {"spinner":"Map_spinner__B5PFt","charger":"Map_charger__xpx7e"};